
































































































































import {Component, Ref, Vue, Watch} from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import { SelectWings } from "wings-ui-components";
import { notifyConfirm, notifyDelete, notifyError } from "@/utils/notify-helper";
import {PriorityRuleItem, PriorityRuleItemImpl} from "@/store/settings/priority_rules/types";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {TransportItem} from "@/store/transport/types";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: { SelectWings }})
export default class PriorityRule extends Vue {
  @Ref('validator') validator:any;
  @Getter("priorityList") priorityList: any;
  @Getter('transports') transportsList!: TransportItem[];

  @Action("getPartners") actionGetPartners: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action('getTemplates') actionGetTemplates: any;
  @Action("getPriorityRuleItem") actionGetItem: any;
  @Action("savePriorityRule") actionSave: any;
  @Action("deletePriorityRule") actionDelete: any;
  @Action('getTransports') actionGetTransports: any;
  @Action("actionLog") actionLog: any;

  private item:PriorityRuleItem = new PriorityRuleItemImpl();
  private itemSaved:PriorityRuleItem = new PriorityRuleItemImpl();
  private logObject: ActionLog = {};

  partnersList: any = []
  originatorsList: any = []
  templatesList:  any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...{transport: this.selectedTransport}, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    const items = await this.actionGetOriginators({transport: this.selectedTransport, partner_id: this.item.partner_id, ...filter});
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async getTemplatesList(filter: any) {
    const items = await this.actionGetTemplates({transport: this.selectedTransport, is_active: 1, ...filter});
    this.templatesList = (filter?.page_number > 1) ? this.templatesList.concat(items) : items
  }

  get selectedTransport(): string | undefined {
    return this.transportsList.find((t: TransportItem) => t.id === this.item.channel_id)?.name;
  }

  async created() {
    this.actionGetTransports();
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "The rule for changing the priority of sending",
          addititional_info: getTranslatedParams(this.item)
        }
        const data = await this.actionGetItem(this.$route.params.id);
        await this.actionLog(this.logObject);
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));

        if (this.item.originator_id) this.originatorsList = await this.actionGetOriginators({id: this.item.originator_id});
        if (this.item.partner_id) this.partnersList = await this.actionGetPartners({id: this.item.partner_id});
        if (this.item.template_id) this.templatesList = await this.actionGetTemplates({transport: this.selectedTransport, filter: {id: this.item.template_id}});
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }

  back():void{
    this.$router.push(`/settings/priority_rules/`);
  }

  onSaveItem():Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "The rule for changing the priority of sending",
            addititional_info: getTranslatedParams(this.item)
          }
          await this.actionSave(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject();
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  async onDeleteItem():Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "The rule for changing the priority of sending",
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  @Watch('item.partner_id')
  onPartnerChanged(val?: number, oldVal?: number) {
    if (oldVal && val !== oldVal) {
      this.item.originator_id = undefined;
      this.item.template_id = undefined;
    }
  }

  @Watch('item.channel_id')
  onChannelChanged(val?: number, oldVal?: number) {
    if (oldVal && val !== oldVal) this.item.partner_id = undefined;
  }
}
